import PrepaidAmountInput from '@components/prepaid/PrepaidAmountInput';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { amountAtom } from '../../../_shared/atoms/prepaidCardAtoms';
import usePrepaidRechargeLimits from '../../../_shared/hooks/usePrepaidRechargeLimits';

function CardInfo() {
    const { t } = useTranslation('prepaidCard');
    const [amount, setAmount] = useAtom(amountAtom);
    const amountMan = amount > 0 ? amount / 10000 : 0;
    const { textParams, getErrorText } = usePrepaidRechargeLimits();
    const errorText = getErrorText(amountMan);

    return (
        <PrepaidAmountInput
            amountMan={amountMan}
            onChangeMan={(man) => setAmount(man * 10000)}
            errorText={errorText}
            placeholder={t('image.amountPlaceholder', textParams)}
            tooltipDaily={t('charge.tooltipDaily', textParams)}
            tooltipMaxBalance={t('charge.tooltipMaxBalance', textParams)}
        />
    );
}

export default CardInfo;
